

























































import { DataProxy } from 'apollo-cache';
import gql from 'graphql-tag';
import * as R from 'ramda';
import Vue from 'vue';

import { Client } from '@/core/entity';

import ClientForm from './Form.vue';
import { listClientQL } from './graphql';

export default Vue.extend({
  components: {
    'form-client': ClientForm,
  },

  apollo: {
    clients: {
      query: listClientQL,
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    const clientId = this.$route.params.client_id;
    return {
      isDrawerVisible: clientId ? true : false,
      loading: false,
    };
  },

  computed: {
    clientId(): string {
      return this.$route.params.client_id;
    },

    drawerTitle(): string {
      return this.clientId ? 'Edit client' : 'Create a new client';
    },
  },

  watch: {
    clientId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    handleSubmit(val: any) {
      const { clientId } = this;
      if (clientId) {
        // edit client
        this.$coreApp.client.update(
          clientId,
          {
            name: val.name,
            country: val.country,
            picName: val.picName,
            picEmail: val.picEmail,
            cse: val.cse,
          },
          this.presenter('Client updated.', 'Unable to update client:', false),
          this.updater,
        );
      } else {
        // create client
        this.$coreApp.client.create(
          {
            name: val.name,
            country: val.country,
            picName: val.picName,
            picEmail: val.picEmail,
            cse: val.cse,
          },
          this.presenter('Client created.', 'Unable to create client:', true),
          this.updater,
        );
      }
    },

    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.clientId) {
        this.$router.back();
      }
    },

    presenter(success: string, failure: string, isNew: boolean) {
      return (err: Error | null, result: Client | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          if (isNew) {
            this.isDrawerVisible = false;
          } else {
            this.$router.push({ name: 'client.list' });
          }
        }
      };
    },

    showDrawer() {
      this.isDrawerVisible = true;
    },

    sortByName: (a: Client, b: Client) => {
      return a.name.localeCompare(b.name);
    },

    updater(
      store: DataProxy,
      res: { data: { newClient?: Client; updateClient?: Client } },
    ) {
      const client = (res.data.updateClient || res.data.newClient) as Client;

      const data: { clients: Client[] } | null = store.readQuery({
        query: listClientQL,
      });

      const isNew = res.data.newClient;
      if (isNew) {
        data!.clients = R.append(client, data!.clients);
        store.writeQuery({
          query: listClientQL,
          data,
        });
      } else {
        const idx = R.findIndex(R.propEq('id', client.id))(data!.clients);
        if (idx !== -1) {
          const previous = data!.clients[idx];
          data!.clients = R.update(
            idx,
            {
              ...previous,
              ...client,
            },
            data!.clients,
          );
          store.writeQuery({
            query: listClientQL,
            data,
          });
        }
      }
    },
  },
});
